"use client";
import { ConsentEmbed } from "../consent/client/api";
import { embedServiceForUrl } from "../consent/presets";
import { Heading, TextAttr, useAttrValue } from "./attributes";
import { useBlock } from "./context";
import { lv } from "../i18n";
import { toPlainText } from "../plain-text";
import type { Localized } from "../types";

/**
 * YouTube, Vimeo or Google Maps by URL, behind a consent placeholder
 * (docs/cookie-consent-plan.md §4.4). The thumbnail is proxied through
 * /api/embed/thumbnail so showing the placeholder never contacts the provider.
 */
export function EmbedBlock() {
  const { editing, locale } = useBlock();
  const raw = useAttrValue<unknown>("url", "");
  const url = toPlainText(typeof raw === "string" ? raw : lv(raw as Localized, locale, "") || "").trim();
  const embed = url ? embedServiceForUrl(url) : null;
  const youtubeId = embed?.serviceId === "youtube" ? embed.embedUrl.match(/embed\/([\w-]+)/)?.[1] : null;
  return <section className="cms-embed-block" style={{ maxWidth: "56rem", marginInline: "auto", padding: "2rem 1.5rem", display: "grid", gap: 12 }}>
    <Heading name="heading" />
    {editing && <label style={{ display: "grid", gap: 4, font: "13px system-ui, sans-serif" }}>
      URL (YouTube, Vimeo, Google Maps)
      <TextAttr name="url" placeholder="https://www.youtube.com/watch?v=…" />
    </label>}
    {embed
      ? <ConsentEmbed service={embed.serviceId} src={embed.embedUrl} title={url} locale={locale} aspectRatio={embed.serviceId === "google-maps" ? "4 / 3" : "16 / 9"}
        thumbnail={youtubeId ? `/api/embed/thumbnail?youtube=${encodeURIComponent(youtubeId)}` : undefined} />
      : editing ? <p style={{ font: "13px system-ui, sans-serif", opacity: 0.7 }}>Plak een link naar een YouTube- of Vimeo-video of een Google Maps-locatie.</p> : null}
    <TextAttr name="caption" as="p" className="cms-embed-caption" />
  </section>;
}
